export default "/images/arrow-down-left.svg?e6a8e7a50a24e0248e8e560e2a3f54f9";